"use strict";

// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://office.visualstudio.com/GSX/_git/AugmentationLoop?path=%2Fmodules%2Ftypes-core%2Fsrc%2Foperations.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MicroSyncOperation = exports.DeltaUpdateOperation = exports.VisibilityOperation = exports.FocusOperation = exports.PurgeOperation = exports.DeleteOperation = exports.UpdateOperation = exports.UpdateAnnotationMetaDataOperation = exports.MoveOperation = exports.AddOperation = exports.OperationWithSiblingContext = exports.Operation = exports.ItemDelta = void 0;
var schema_object_g_1 = require("./schema-object.g");
var ItemDelta = /** @class */function () {
  function ItemDelta(obj) {
    schema_object_g_1.SchemaObject.assign(ItemDelta, this, obj);
  }
  ItemDelta.getTypeName = function () {
    return 'AugLoop_Core_ItemDelta';
  };
  ItemDelta.getBaseTypes = function () {
    return [];
  };
  ItemDelta.H_ = {
    T_: ItemDelta.getTypeName(),
    B_: ItemDelta.getBaseTypes()
  };
  return ItemDelta;
}();
exports.ItemDelta = ItemDelta;
var Operation = /** @class */function () {
  function Operation(obj) {
    schema_object_g_1.SchemaObject.assign(Operation, this, obj);
  }
  Operation.getTypeName = function () {
    return 'AugLoop_Core_Operation';
  };
  Operation.getBaseTypes = function () {
    return [];
  };
  Operation.H_ = {
    T_: Operation.getTypeName(),
    B_: Operation.getBaseTypes()
  };
  return Operation;
}();
exports.Operation = Operation;
var OperationWithSiblingContext = /** @class */function () {
  function OperationWithSiblingContext(obj) {
    schema_object_g_1.SchemaObject.assign(OperationWithSiblingContext, this, obj);
  }
  OperationWithSiblingContext.getTypeName = function () {
    return 'AugLoop_Core_OperationWithSiblingContext';
  };
  OperationWithSiblingContext.getBaseTypes = function () {
    return ['AugLoop_Core_Operation'];
  };
  OperationWithSiblingContext.H_ = {
    T_: OperationWithSiblingContext.getTypeName(),
    B_: OperationWithSiblingContext.getBaseTypes()
  };
  return OperationWithSiblingContext;
}();
exports.OperationWithSiblingContext = OperationWithSiblingContext;
var AddOperation = /** @class */function () {
  function AddOperation(obj) {
    schema_object_g_1.SchemaObject.assign(AddOperation, this, obj);
  }
  AddOperation.getTypeName = function () {
    return 'AugLoop_Core_AddOperation';
  };
  AddOperation.getBaseTypes = function () {
    return ['AugLoop_Core_OperationWithSiblingContext', 'AugLoop_Core_Operation'];
  };
  AddOperation.H_ = {
    T_: AddOperation.getTypeName(),
    B_: AddOperation.getBaseTypes()
  };
  return AddOperation;
}();
exports.AddOperation = AddOperation;
var MoveOperation = /** @class */function () {
  function MoveOperation(obj) {
    schema_object_g_1.SchemaObject.assign(MoveOperation, this, obj);
  }
  MoveOperation.getTypeName = function () {
    return 'AugLoop_Core_MoveOperation';
  };
  MoveOperation.getBaseTypes = function () {
    return ['AugLoop_Core_OperationWithSiblingContext', 'AugLoop_Core_Operation'];
  };
  MoveOperation.H_ = {
    T_: MoveOperation.getTypeName(),
    B_: MoveOperation.getBaseTypes()
  };
  return MoveOperation;
}();
exports.MoveOperation = MoveOperation;
var UpdateAnnotationMetaDataOperation = /** @class */function () {
  function UpdateAnnotationMetaDataOperation(obj) {
    schema_object_g_1.SchemaObject.assign(UpdateAnnotationMetaDataOperation, this, obj);
  }
  UpdateAnnotationMetaDataOperation.getTypeName = function () {
    return 'AugLoop_Core_UpdateAnnotationMetaDataOperation';
  };
  UpdateAnnotationMetaDataOperation.getBaseTypes = function () {
    return ['AugLoop_Core_Operation'];
  };
  UpdateAnnotationMetaDataOperation.H_ = {
    T_: UpdateAnnotationMetaDataOperation.getTypeName(),
    B_: UpdateAnnotationMetaDataOperation.getBaseTypes()
  };
  return UpdateAnnotationMetaDataOperation;
}();
exports.UpdateAnnotationMetaDataOperation = UpdateAnnotationMetaDataOperation;
var UpdateOperation = /** @class */function () {
  function UpdateOperation(obj) {
    schema_object_g_1.SchemaObject.assign(UpdateOperation, this, obj);
  }
  UpdateOperation.getTypeName = function () {
    return 'AugLoop_Core_UpdateOperation';
  };
  UpdateOperation.getBaseTypes = function () {
    return ['AugLoop_Core_Operation'];
  };
  UpdateOperation.H_ = {
    T_: UpdateOperation.getTypeName(),
    B_: UpdateOperation.getBaseTypes()
  };
  return UpdateOperation;
}();
exports.UpdateOperation = UpdateOperation;
var DeleteOperation = /** @class */function () {
  function DeleteOperation(obj) {
    schema_object_g_1.SchemaObject.assign(DeleteOperation, this, obj);
  }
  DeleteOperation.getTypeName = function () {
    return 'AugLoop_Core_DeleteOperation';
  };
  DeleteOperation.getBaseTypes = function () {
    return ['AugLoop_Core_Operation'];
  };
  DeleteOperation.H_ = {
    T_: DeleteOperation.getTypeName(),
    B_: DeleteOperation.getBaseTypes()
  };
  return DeleteOperation;
}();
exports.DeleteOperation = DeleteOperation;
var PurgeOperation = /** @class */function () {
  function PurgeOperation(obj) {
    schema_object_g_1.SchemaObject.assign(PurgeOperation, this, obj);
  }
  PurgeOperation.getTypeName = function () {
    return 'AugLoop_Core_PurgeOperation';
  };
  PurgeOperation.getBaseTypes = function () {
    return ['AugLoop_Core_Operation'];
  };
  PurgeOperation.H_ = {
    T_: PurgeOperation.getTypeName(),
    B_: PurgeOperation.getBaseTypes()
  };
  return PurgeOperation;
}();
exports.PurgeOperation = PurgeOperation;
var FocusOperation = /** @class */function () {
  function FocusOperation(obj) {
    schema_object_g_1.SchemaObject.assign(FocusOperation, this, obj);
  }
  FocusOperation.getTypeName = function () {
    return 'AugLoop_Core_FocusOperation';
  };
  FocusOperation.getBaseTypes = function () {
    return ['AugLoop_Core_Operation'];
  };
  FocusOperation.H_ = {
    T_: FocusOperation.getTypeName(),
    B_: FocusOperation.getBaseTypes()
  };
  return FocusOperation;
}();
exports.FocusOperation = FocusOperation;
var VisibilityOperation = /** @class */function () {
  function VisibilityOperation(obj) {
    schema_object_g_1.SchemaObject.assign(VisibilityOperation, this, obj);
  }
  VisibilityOperation.getTypeName = function () {
    return 'AugLoop_Core_VisibilityOperation';
  };
  VisibilityOperation.getBaseTypes = function () {
    return ['AugLoop_Core_Operation'];
  };
  VisibilityOperation.H_ = {
    T_: VisibilityOperation.getTypeName(),
    B_: VisibilityOperation.getBaseTypes()
  };
  return VisibilityOperation;
}();
exports.VisibilityOperation = VisibilityOperation;
var DeltaUpdateOperation = /** @class */function () {
  function DeltaUpdateOperation(obj) {
    schema_object_g_1.SchemaObject.assign(DeltaUpdateOperation, this, obj);
  }
  DeltaUpdateOperation.getTypeName = function () {
    return 'AugLoop_Core_DeltaUpdateOperation';
  };
  DeltaUpdateOperation.getBaseTypes = function () {
    return ['AugLoop_Core_Operation'];
  };
  DeltaUpdateOperation.H_ = {
    T_: DeltaUpdateOperation.getTypeName(),
    B_: DeltaUpdateOperation.getBaseTypes()
  };
  return DeltaUpdateOperation;
}();
exports.DeltaUpdateOperation = DeltaUpdateOperation;
var MicroSyncOperation = /** @class */function () {
  function MicroSyncOperation(obj) {
    schema_object_g_1.SchemaObject.assign(MicroSyncOperation, this, obj);
  }
  MicroSyncOperation.getTypeName = function () {
    return 'AugLoop_Core_MicroSyncOperation';
  };
  MicroSyncOperation.getBaseTypes = function () {
    return ['AugLoop_Core_Operation'];
  };
  MicroSyncOperation.H_ = {
    T_: MicroSyncOperation.getTypeName(),
    B_: MicroSyncOperation.getBaseTypes()
  };
  return MicroSyncOperation;
}();
exports.MicroSyncOperation = MicroSyncOperation;